




















































































import { SfFooter, SfImage, SfLink } from "@storefront-ui/vue";
import { defineComponent, ref } from "@nuxtjs/composition-api";
import { addBasePath } from "~/helpers/addBasePath";
import RelatedSite from "~/components/General/RelatedSite.vue";
import { computed } from "@nuxtjs/composition-api";
import { useConfig, useGtm } from "~/composables";
import {debounce, filter, isEmpty} from 'lodash-es';

export default defineComponent({
  components: {
    SfFooter,
    SfImage,
    SfLink,
    RelatedSite,
  },
  setup() {
    const { eventCustomlinksInteracted } = useGtm();
    const { config } = useConfig();
    const copyrightText = computed(() => {
      const copyright = config.value.copyright;
      return copyright ? copyright : "";
    });
    const icpLink = computed(() => {
      const icp_link = config.value.icp_link;
      return icp_link ? icp_link : "";
    });
    const icpNumber = computed(() => {
      const icp_number = config.value.icp_number;
      return icp_number ? icp_number : "";
    });
    const policyBeianEnable = computed(() => {
      const policy_beian_enable = config.value.policy_beian_enable;
      return policy_beian_enable ? policy_beian_enable : "";
    });
    const policyBeianNumber = computed(() => {
      const policy_beian_number = config.value.policy_beian_number;
      return policy_beian_number ? policy_beian_number : "";
    });
    const policyBeianLink = computed(() => {
      const policy_beian_link = config.value.policy_beian_link;
      return policy_beian_link ? policy_beian_link : "";
    });
    const clientWidth = ref(null);
    const footerImg = ref(null);
    const footerImages = {
      3840: { img: "footer-image_Extra-Large_3840" },
      1920: { img: "footer-image_D-Large_1920" },
      1728: { img: "footer-image_Extra-Large_1728" },
      1440: { img: "footer-image_D-Medium_1440" },
      1366: { img: "footer-image_D-Small_1366" },
      1280: { img: "footer-image_D-Extrasmall_1280" },
      1024: { img: "footer-image_T-Large_1024" },
      768: { img: "footer-image_T-Small_767" },
      640: { img: "footer-image_M-Large_560" },
      380: { img: "footer-image_M-Extra-small_349" },
      320: { img: "footer-image_M-smallest_302" },
    };
    const screenSizes = [
      3840, 1920, 1728, 1440, 1366, 1280, 1024, 768, 640, 380, 320,
    ];

    const currentScreenSize = ref(null);

    const handleResize = function () {
      clientWidth.value = document.body.clientWidth
        ? document.body.clientWidth
        : clientWidth;

      const imageSize = filter(screenSizes, (o) => o >= clientWidth.value).pop() ?? 320;
      const newFooterImg = "/footer/" + footerImages[imageSize].img + ".webp";
      (isEmpty(footerImg.value) || footerImg.value !== newFooterImg) && (footerImg.value = newFooterImg);
      currentScreenSize.value = imageSize;
    };

    const footerImageHeight = computed(() => {
      const aspectRatio = ref(null);
      switch (currentScreenSize.value) {
        case 3840:
        case 1920:
        case 1728:
        case 1440:
          aspectRatio.value = 12 / 5;
          break;
        case 1366:
          aspectRatio.value = 1366 / 601;
          break;
        case 1280:
          aspectRatio.value = 32 / 15;
          break;
        case 1024:
          aspectRatio.value = 1024 / 601;
          break;
        case 767:
          aspectRatio.value = 767 / 593;
          break;
        case 560:
          aspectRatio.value = 280 / 297;
          break;
        case 480:
          aspectRatio.value = 480 / 593;
          break;
        case 354:
          aspectRatio.value = 177 / 280;
          break;
        case 349:
          aspectRatio.value = 349 / 560;
          break;
        case 302:
          aspectRatio.value = 151 / 280;
          break;
        default:
          aspectRatio.value = 12 / 5;
      }
      const height = Math.round(document.body.clientWidth / aspectRatio.value);
      return (currentScreenSize.value <= 768) ? 460 : height;
    });

    handleResize();
    window.addEventListener("resize", debounce(handleResize, 300));

    const footerTracking = (label) => {
      eventCustomlinksInteracted({
        "eventlabel": label,
        "eventCategory": "Footer Links",
      });
    };

    return {
      addBasePath,
      clientWidth: document.body.clientWidth,
      aboutUs: ["Who we are", "Quality in the details", "Customer Reviews"],
      departments: ["Women fashion", "Men fashion", "Kidswear", "Home"],
      help: [
        { title: "Customer service" },
        { title: "Size guide" },
        { title: "FQA", link: "/faq" },
        { title: "Terms & Conditions", link: "/terms-conditions" },
        { title: "Contact us", link: "contact" },
      ],
      paymentsDelivery: ["Purchase terms", "Guarantee"],
      social: ["facebook", "pinterest", "google", "twitter", "youtube"],
      isMobile: false,
      desktopMin: 1024,
      socialMediaLinks: [{ title: "Wechat", url: "", icon: "wechat.svg" }],
      relatedSiteData: [
        { title: "Bekaert Global", url: "https://www.bekaert.com/" },
        { title: "Bekaert Japan", url: "https://www.bekaert.co.jp/" },
        { title: "Bekaert Costa Rica, Central America & Caribbean", url: "/" },
        { title: "Bekaert Latin America", url: "/" },
        {
          title: "Bekaert Fencing North America",
          url: "https://fencing.bekaert.com/en",
        },
        {
          title: "Bekaert Construction North America",
          url: "https://construction.bekaert.com",
        },
      ],
      screenSizes,
      footerImages,
      footerImg,
      copyrightText,
      icpNumber,
      icpLink,
      footerImageHeight,
      policyBeianEnable,
      policyBeianNumber,
      policyBeianLink,
      footerTracking,
      eventCustomlinksInteracted,
    };
  },
});
